exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".icon__2V2a {\n  margin-left: auto;\n  padding: 3px 10px;\n  display: none; }\n\n.icon__2V2a svg {\n  pointer-events: none; }\n\n.collapsible-option__3_q1:hover .icon__2V2a {\n  display: block; }\n\n.dialog__2nXr {\n  height: 450px; }\n\n.dialog-footer__3wYJ {\n  display: flex;\n  width: 100%; }\n", "", {"version":3,"sources":["/app/src/ui/inline-text/style-tab-content-components/src/ui/inline-text/style-tab-content-components/font-picker-font-family.scss"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc,EACf;;AAED;EACE,qBAAqB,EACtB;;AAED;EACE,eAAe,EAChB;;AAED;EACE,cAAc,EACf;;AAED;EACE,cAAc;EACd,YAAY,EACb","file":"font-picker-font-family.scss","sourcesContent":["@import '~themes/nighthawks';\n\n.icon {\n  margin-left: auto;\n  padding: 3px 10px;\n  display: none;\n}\n\n.icon svg {\n  pointer-events: none;\n}\n\n.collapsible-option:hover .icon {\n  display: block;\n}\n\n.dialog {\n  height: 450px;\n}\n\n.dialog-footer {\n  display: flex;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "icon__2V2a",
	"collapsible-option": "collapsible-option__3_q1",
	"dialog": "dialog__2nXr",
	"dialog-footer": "dialog-footer__3wYJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/ui/inline-text/style-tab-content-components/font-picker-font-family.scss
// module id = 1419
// module chunks = 0